<script setup>
import {computed, inject, useSlots} from 'vue'

const slots = useSlots()

const props = defineProps({
    title: {
        type: String,
        required: false,
        default: '',
    },
    localizetitle: {
        type: Boolean,
        required: false,
        default: false,
    },
    value: {
        type: String,
        required: true
    },
    active: {
        type: Boolean,
        required: false,
        default: false
    },
    unlocked: {
        type: Boolean,
        required: false,
        default: true
    }
})

const currentStepSlug = inject('currentStepSlug')
const goToPrevious = inject('goToPrevious')
const goToNext = inject('goToNext')
const previousIsPresent = inject('previousIsPresent')
const canGoToPrevious = inject('canGoToPrevious')
const nextIsPresent = inject('nextIsPresent')
const canGoToNext = inject('canGoToNext')
const globalActionRightSlot = inject('globalActionRightSlot', null)

const globalActionRightContent = computed(() => globalActionRightSlot?.value ?? null)
const hasActionLeft = computed(() => !!slots['action-left'])
const hasActionRight = computed(() => !!slots['action-right'])
const hasGlobalActionRight = computed(() => !!globalActionRightContent.value)
const showActionArea = computed(() => hasActionLeft.value || hasActionRight.value || hasGlobalActionRight.value || previousIsPresent?.value || nextIsPresent?.value)
const showTooltipRow = computed(() => !!slots['prev-button-tooltip'] || !!slots['next-button-tooltip'])
</script>
<template>
    <div
        v-show="value === currentStepSlug"
        class="relative"
    >
        <slot></slot>

        <div
            v-if="showActionArea"
            class="flex justify-between mt-8"
        >
            <div
                v-if="showTooltipRow"
                class="text-xs text-gray-500 text-left pb-1"
            >
                <slot name="prev-button-tooltip"></slot>
            </div>
            <div
                v-if="showTooltipRow"
                class="text-xs text-gray-500 text-right pb-1"
            >
                <slot name="next-button-tooltip"></slot>
            </div>
        </div>
        <div
            v-if="showActionArea"
            class="flex justify-between"
        >
            <div class="space-x-2">
                <button-base
                    v-if="previousIsPresent && ! canGoToPrevious"
                    disabled
                    style-type="disabled"
                >
                    {{ _mft('shared:previous') }}
                </button-base>
                <button-secondary
                    v-if="canGoToPrevious"
                    @click="goToPrevious"
                >
                    {{ _mft('shared:previous') }}
                </button-secondary>
                <slot name="action-left">
                </slot>
            </div>
            <div>
                <div class="flex space-x-2">
                    <template v-if="hasGlobalActionRight">
                        <component
                            v-for="(node, index) in globalActionRightContent"
                            :key="index"
                            :is="node"
                        />
                    </template>
                    <slot name="action-right"></slot>
                    <div>
                        <button-base
                            v-if="nextIsPresent && ! canGoToNext"
                            style-type="disabled"
                            disabled
                        >
                            {{ _mft('shared:next') }}
                        </button-base>
                        <button-secondary
                            v-if="canGoToNext"
                            @click="goToNext"
                        >
                            {{ _mft('shared:next') }}
                        </button-secondary>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
